import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { TextField, Autocomplete, MenuItem } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import { useNavigate, useParams } from "react-router-dom";
import { Modal } from "bootstrap";
import { useDispatch } from "react-redux";
// css
import "./Projectdetails.css";
import searchbtn from "../../../Assets/images/search.svg";
import Pagination from "../../Pagination/Pagination";
import deleteimg from "../../../Assets/images/delete-img.png";
import pdfimg from "../../../Assets/images/pdf_img.png";
import url from "../../../Assets/images/url.png";
import "@fortawesome/fontawesome-free/css/all.min.css";
// custom import
import showToast from "../../../Utils/Toast/ToastNotification";
import { HandleApiError } from "../../../Utils/CommonErrors/HandleApiError";
import {
  hideLoader,
  showLoader,
} from "../../../Redux/Slice/Loader/loaderSlice";
import projectManagementService from "../../../Services/projectManagementService/projectManagementService";
import inspectionService from "../../../Services/inspectionService/inspectionService";
import userManagementService from "../../../Services/UserManagement/UserManagementService";
import { getDisplayFileName } from "../../../Utils/fileDisplayName";

const ProjectDetails = () => {
  const inspectionDate_from = useRef(null);
  const inspectionDate_to = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const [project, setProject] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchQuery, setSearchQuery] = useState("");
  const [totalRecords, setTotalRecords] = useState(0);
  const [sortBy, setSortBy] = useState("inspection_date");
  const [sortOrder, setSortOrder] = useState("DESC");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [selectedId, setSelectedId] = useState(null);
  const [inspection, setInspection] = useState([]);
  const [users, setUsers] = useState([]);
  const [isFilterCleared, setIsFilterCleared] = useState(false);
  const [showArchived, setShowArchived] = useState(false);
  const [filters, setFilters] = useState({
    inspectionDate_from: "",
    inspectionDate_to: "",
    status: "",
    inspector_id: [],
    page: 1,
    limit: 10,
  });
  const [projectId, setProjectId] = useState(null);
  const [inspectionStatus, setInspectionStatus] = useState(null)
  const [inspectionId, setInspectionId] = useState(null);

  const user_id = useSelector(
    (state) => state.auth?.user?.data?.body?.data?.userData?.id
  );

  const token = useSelector(
    (state) => state.auth?.user?.data?.body?.data?.token
  );


  const handleFocus = (ref) => {
    if (ref.current) {
      ref.current.showPicker?.(); // Open date picker if supported
    }
  };

  const modalRef = useRef(null);

  const openModal = () => {
    if (modalRef.current) {
      const modalInstance = new Modal(modalRef.current, { backdrop: "static" });

      const oldInstance = Modal.getInstance(modalRef.current);
      if (oldInstance) {
        oldInstance.dispose();
      }
      const newInstance = new Modal(modalRef.current, { backdrop: "static" });
      newInstance.show();
    }
  };

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
    setPage(0);
  };

  const handleSort = (column) => {
    if (sortBy === column) {
      setSortOrder(sortOrder === "ASC" ? "DESC" : "ASC");
    } else {
      setSortBy(column);
      setSortOrder("ASC");
    }
  };

  const handleFilterChange = (e) => {
    const { id, value } = e.target;
    setFilters((prevFilters) => ({
      ...prevFilters,
      [id]: value,
    }));
  };

  const handleFilterSubmit = (e) => {
    e.preventDefault();
    getInpsectionList();
  };

  const handleClearFilter = (e) => {
    e.preventDefault();

    setFilters({
      inspectionDate_from: "",
      inspectionDate_to: "",
      status: "",
      inspector_id: [],
      page: page + 1,
      limit: rowsPerPage,
    });
    setIsFilterCleared(true);
    setSearchQuery("");
    if (inspectionDate_from.current) inspectionDate_from.current.value = "";
    if (inspectionDate_to.current) inspectionDate_to.current.value = "";
    // getInpsectionList();
  };

  const getInpsectionList = async () => {
    dispatch(showLoader());
    const params = {
      search: searchQuery || "",
      page: page + 1,
      project_id: id,
      limit: rowsPerPage,
      sort_by: `"${sortBy}"`,
      sort_order: sortOrder,
      inspectionDate_from: filters.inspectionDate_from,
      inspectionDate_to: filters.inspectionDate_to,
      status: filters.status,
      inspector_id: filters.inspector_id.map((user) => user.id).join(","),
      is_archived: showArchived ? "" : "false",
    };
    try {
      const response = await inspectionService.getInspectionforProject(params, token);
      if (response?.data?.statusCode == 200) {
        const inspectionList = response?.data?.body?.data?.inspection || [];
        const totalItems = response?.data?.body?.data?.total || 0;

        if (inspectionList.length === 0 && page > 0) {
          setPage((prev) => prev - 1);
        } else {
          setInspection(inspectionList);
          setTotalRecords(totalItems);
        }
      } else {
        showToast("error", response.data.body?.message);
      }
    } catch (error) {
      await HandleApiError(error);
    } finally {
      dispatch(hideLoader());
    }
  };

  const handleInspector = (event, newValue) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      inspector_id: newValue, // KEEP AS ARRAY
    }));
  };

  const handleDelete = async () => {
    try {
      const params = {
        inspection_id: selectedId,
        deleted_by: user_id,
      };
      await inspectionService.deleteInspection(params, token);
      showToast("success", "Inspection Deleted successfully");
      await getInpsectionList();
    } catch (error) {
      await HandleApiError(error);
    }
  };

  const handleArchive = async () => {
    try {
      showLoader(true);
      const params = {
        inspection_id: selectedId,
        deleted_by: user_id,
      };
      await inspectionService.archiveInspection(params, token);
      showToast("success", "Inspection archived successfully");
      await getInpsectionList();
    } catch (error) {
      await HandleApiError(error);
    } finally {
      showLoader(false);
    }
  };

  const getAllUser = async () => {
    try {
      const response = await userManagementService.getAllUserList(token);
      if (response?.data?.statusCode === 200) {
        setUsers(response.data?.body?.data?.users);
      } else {
        showToast("error", response.data.body.message);
      }
    } catch (error) {
      await HandleApiError(error);
    }
  };

  const cloneInspection = async () => {
    try {
      const response = await inspectionService.cloneInspection({
        id: selectedId,
      }, token);
      if (response?.data.statusCode === 200) {
        showToast("success", response.data.body.message);
        getInpsectionList();
      } else {
        showToast("error", response.body.message);
      }
      await getInpsectionList();
    } catch (error) {
      await HandleApiError(error);
    }
  };

  useEffect(() => {
    if (isFilterCleared) {
      getInpsectionList();
      setIsFilterCleared(false);
    }
  }, [isFilterCleared]);

  useEffect(() => {
    getInpsectionList();
  }, [debouncedSearch, page, rowsPerPage, sortBy, sortOrder]);

  useEffect(() => {
    getAllUser();
  }, []);

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      setDebouncedSearch(searchQuery);
    }, 500);

    return () => clearTimeout(delayDebounce);
  }, [searchQuery]);

  const getProject = async () => {
    dispatch(showLoader());
    try {
      const response = await projectManagementService.getProject(id, token);
      if (response?.data?.statusCode === 200) {
        setProject(response?.data?.body?.data);
        setProjectId(response?.data?.body?.data.id);
      } else {
        showToast("error", response?.data?.body?.message);
      }
    } catch (error) {
      await HandleApiError(error);
    } finally {
      dispatch(hideLoader());
    }
  };

  const handleChangePage = (newPage) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (e) => {
    setRowsPerPage(e.target.value);
    setPage(0);
  };

  useEffect(() => {
    getProject();
  }, [id]);

  useEffect(() => {
    getInpsectionList();
  }, [showArchived]);

  if (!project) {
    return null;
  }

  return (
    <div className="main-inner-block">
      <div className='heading-content'>
        Project Details
      </div>
      <div className="content">
        <div className="white-box bg-box-mob">
          <div class="create-user-block">
            <div className="add-project-area ">

              {/* project details block */}
              <div className="add-project-inner">
                <h6 className="heading-content m-0 heading-text">Project Details</h6>
                <div className="project-details-view d-flex flex-wrap">
                  <div className="profile-box">
                    <label for="firstName" class="form-label m-0">
                      Project Type
                    </label>
                    <div className="form-input-block">
                      {project.project_type.name}
                    </div>
                  </div>
                  <div className="profile-box">
                    <label for="lastName" class="form-label m-0">
                      Project Coordinators
                    </label>
                    <div className="form-input-block">
                      {project.coordinators.length > 0
                        ? project.coordinators
                          .map(
                            (coordinator) =>
                              `${coordinator.first_name} ${coordinator.last_name}`
                          )
                          .join(", ")
                        : "No Coordinators"}
                    </div>
                  </div>
                  <div className="profile-box">
                    <label for="firstName" class="form-label m-0">
                      Start Date
                    </label>
                    <div className="form-input-block">
                      {new Date(project.startDate).toLocaleDateString()}
                    </div>
                  </div>
                  <div className="profile-box">
                    <label for="firstName" class="form-label m-0">
                      End Date
                    </label>
                    <div className="form-input-block">
                      {project.endDate
                        ? new Date(project.endDate).toLocaleDateString()
                        : "-"}
                    </div>
                  </div>
                  <div className="profile-box">
                    <label for="firstName" class="form-label m-0">
                      Status
                    </label>
                    <div className="form-input-block">{project.status}</div>
                  </div>
                </div>
              </div>

              {/* project address block */}
              <div className="add-project-inner">
                <h6 className="heading-content m-0 heading-text">Address</h6>
                <div className="project-details-section">
                  <div className="add-project-box">
                    <label for="firstName" class="form-label m-0">
                      Project Address
                    </label>
                    <div className="form-input-block">
                      {project.streetAddress} {project.suburb} {project.state_name}{" "}
                      {project.postCode}
                    </div>
                  </div>
                </div>
              </div>

              {/* relevant documents */}
              <div className="add-project-inner">
                <h6 className="heading-content m-0 heading-text">Relevant Documents</h6>
                <div className="project-details-section row">
                  <div className="profile-box col-md-4 mb-3">
                    <label for="firstName" class="form-label m-0">
                      Project Plan
                    </label>
                    <div className="form-input-block text-break">
                      <span className="me-2">
                        <img src={pdfimg} alt="project-plan"></img>
                      </span>
                      <span>
                        {project.planFileUrl ? (
                          <a
                            href={project.planFileUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              color: "inherit",
                              textDecoration: "none",
                              cursor: "pointer",
                            }}
                          >
                            {getDisplayFileName(project.planFileUrl)}
                          </a>
                        ) : (
                          "No file available"
                        )}
                      </span>
                    </div>
                  </div>

                  <div className="profile-box col-md-4 mb-3">
                    <label for="firstName" class="form-label m-0">
                      Other Files
                    </label>
                    <div className="form-input-block">
                      {project.other_files?.length > 0 ? (
                        project.other_files.map((file, index) => {
                          const filePath =
                            typeof file === "string" ? file : file?.file_path || ""; // Adjust based on actual structure


                          return (
                            <div key={index}>
                              <span className="me-2">
                                <img src={pdfimg} alt="project-plan"></img>
                              </span>
                              <a
                                href={filePath}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  color: "inherit",
                                  textDecoration: "none",
                                  cursor: "pointer",
                                }}
                              >
                                {filePath
                                  ? getDisplayFileName(file)
                                  : "Invalid file path"}
                              </a>
                            </div>
                          );
                        })
                      ) : (
                        <span>No files available</span>
                      )}
                    </div>
                  </div>

                  <div className="profile-box col-md-4 mb-3">
                    <label for="document_urls" class="form-label m-0"> Document Urls</label>
                    <div className="form-input-block scrollable-section" >
                      {project?.allDocumenetUrls?.length > 0
                        ? project.allDocumenetUrls.map((file, index) => {
                          const filePath =
                            typeof file === "string" ? file : file?.file_path || "";

                          const displayText = filePath.length > 20
                            ? filePath.substring(0, 20) + "..."
                            : filePath
                          return (
                            <div key={index}>
                              <span >
                                <img src={url} alt="project-plan" className="link-class"></img>
                              </span>
                              <a
                                href={filePath}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  color: "blue",
                                  textDecoration: "none",
                                  cursor: "pointer",
                                }}
                                title={filePath}
                              >
                                {displayText}
                              </a>
                            </div>
                          );
                        }) : (<div>-</div>)
                      }

                    </div>


                  </div>
                </div>
              </div>


              {/* project client details block */}
              <div className="add-project-inner">
                <h6 className="heading-content m-0 heading-text">Client Details</h6>
                <div className="project-details-section row">
                  <div className="profile-box col-md-6">
                    <label for="firstName" class="form-label m-0">
                      Client Name
                    </label>
                    <div className="form-input-block">
                      {project.client_name ? project.client_name : "-"}
                    </div>
                  </div>
                  <div className="profile-box col-md-6">
                    <label for="firstName" class="form-label m-0">
                      Client Email
                    </label>
                    <div className="form-input-block">
                      {project.client_name ? project.client_email : "-"}

                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="btn-box text-center mt-3 mb-4 d-flex align-items-center gap-1 justify-content-center">
              <button
                type="submit"
                class="green-btn submit-btn"
                onClick={() => navigate("/project-listing")}
              >
                Back
              </button>

              <button
                type="submit"
                class="green-btn submit-btn"
                onClick={() => navigate(`/update-project/${project.id}`)}
              >
                Edit Details
              </button>

              <button
                type="submit"
                class="green-btn submit-btn"
                onClick={() =>
                  navigate(`/add-inspection`, { state: { projectId } })
                }
              >
                + Add Inspection
              </button>
            </div>
          </div>


          <div className="inner-content-block">
            <div className="listing-title-block d-flex justify-content-between">
              <div className="box-listing-title">
                Inspection List
                <span className="d-block">
                  Showing a list of Inspections List.
                </span>
              </div>
              <div className="searchbar-btn d-flex align-items-center gap-4">
                <div className="toggle-archive d-flex align-items-center">
                  <label
                    className="form-check-label me-2"
                    htmlFor="archiveToggle"
                  >
                    Show Archived
                  </label>
                  <div className="form-check form-switch">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="archiveToggle"
                      checked={showArchived}
                      onChange={(e) => setShowArchived(e.target.checked)}
                    />
                  </div>
                </div>

                <div className="input-search-box position-relative">
                  <input
                    type="text"
                    id="name"
                    placeholder="Search"
                    value={searchQuery}
                    onChange={handleSearch}
                  />
                  <div className="searchbtn">
                    <img src={searchbtn} alt="searchbtn"></img>
                  </div>
                  {searchQuery && (
                    <button
                      className="clear-btn"
                      onClick={() => setSearchQuery("")}
                    >
                      ✖
                    </button>
                  )}
                </div>
                <div className="filter d-flex align-items-center gap-4">
                  <a
                    className="filter-inner"
                    href="#"
                    data-bs-toggle="modal"
                    data-bs-target="#exampleModal"
                    onClick={(e) => {
                      e.preventDefault();
                      openModal();
                    }}
                  >
                    <span className="me-2">
                      <svg
                        width="20"
                        height="21"
                        viewBox="0 0 20 21"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M5 10.332H15M2.5 5.33203H17.5M7.5 15.332H12.5"
                          stroke="#475467"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </span>
                    Filter
                  </a>
                  <div
                    class="modal fade"
                    id="exampleModal"
                    tabindex="-1"
                    aria-labelledby="exampleModalLabel"
                    aria-hidden="true"
                  >
                    <div class="modal-dialog modal-dialog-centered">
                      <div class="modal-content">
                        <div className="text-end">
                          <button
                            type="button"
                            class="btn-close "
                            data-bs-dismiss="modal"
                            aria-label="Close"
                          ></button>
                        </div>

                        <div>
                          <h1
                            class="modal-title fs-5 text-center filter-title"
                            id="exampleModalLabel"
                          >
                            Inspection Management Filter
                          </h1>
                        </div>
                        <div class="modal-body">
                          <form
                            onSubmit={(e) => {
                              e.preventDefault();
                              getInpsectionList();
                            }}
                          >
                            <div class="mb-3">
                              <label for="inspector_id" class="form-label">
                                Inspector
                              </label>
                              <Autocomplete
                                className="autocomplete-box position-relative"
                                name="inspector_id"
                                multiple
                                options={users}
                                getOptionLabel={(option) => option?.name || ""}
                                disableCloseOnSelect
                                value={filters.inspector_id}
                                onChange={handleInspector}
                                sx={{
                                  m: 1,
                                  // width: 375,
                                  "& .MuiOutlinedInput-root": {
                                    "& .MuiOutlinedInput-notchedOutline": {
                                      border: "1px solid #e6e6e6 !important",
                                    },
                                    "&:before, &:after": {
                                      border: "1px solid #e6e6e6 !important",
                                    },
                                    "&.Mui-focused:after": {
                                      border: "1px solid #e6e6e6 !important",
                                    },
                                  },
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    variant="outlined"
                                    className="coordinator"
                                    placeholder={
                                      filters.inspector_id && filters.inspector_id.length > 0
                                        ? ""
                                        : "Select Inspector"
                                    }
                                  />
                                )}
                                renderOption={(props, option, { selected }) => (
                                  <MenuItem
                                    {...props}
                                    key={option.user_id}
                                    sx={{ justifyContent: "space-between" }}
                                  >
                                    {`${option.name}`}
                                    {selected ? (
                                      <CheckIcon color="info" />
                                    ) : null}
                                  </MenuItem>
                                )}
                              />
                            </div>

                            <div class="mb-3">
                              <label for="status" class="form-label">
                                Status
                              </label>
                              <select
                                className="form-select"
                                id="status"
                                value={filters.status}
                                onChange={handleFilterChange}
                              >
                                <option disabled value="">
                                  Select Status{" "}
                                </option>
                                <option value="Scheduled">Scheduled </option>
                                <option value="Not Started">Not Started</option>
                                <option value="In Progress">In Progress</option>
                                <option value="Complete">Complete</option>
                                <option value="Archive">Archive</option>
                              </select>
                            </div>

                            <div class="mb-3">
                              <label className="form-label">Date</label>
                              <div className="d-flex gap-2">
                                <input
                                  type="date"
                                  className="form-control"
                                  id="inspectionDate_from"
                                  name="inspectionDate_from"
                                  onChange={handleFilterChange}
                                  ref={inspectionDate_from}
                                  onClick={() =>
                                    handleFocus(inspectionDate_from)
                                  }
                                  placeholder="From"
                                />{" "}
                                <span>-</span>
                                <input
                                  type="date"
                                  className="form-control"
                                  id="inspectionDate_to"
                                  name="inspectionDate_to"
                                  ref={inspectionDate_to}
                                  onChange={handleFilterChange}
                                  onClick={() => handleFocus(inspectionDate_to)}
                                  placeholder="To"
                                />
                              </div>
                            </div>
                            <div className="text-center">
                              <button
                                type="submit"
                                class="green-btn updt-button"
                                data-bs-dismiss="modal"
                                onClick={(e) => handleFilterSubmit(e)}
                              >
                                Filter
                              </button>
                              <button
                                type="submit"
                                class="green-btn updt-button ms-2"
                                data-bs-dismiss="modal"
                                onClick={handleClearFilter}
                              >
                                Clear Filter
                              </button>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="table-block">
              <table class="table">
                <thead class="table-headers">
                  <tr>
                    <th>Inspection Title</th>
                    <th onClick={() => handleSort("project_address")}>
                      Project Address
                      <span className="ms-1">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          version="1.1"
                          width="10"
                          height="17"
                          viewBox="0 0 32 32"
                        >
                          <g>
                            <path
                              d="M7 13h18a1 1 0 0 0 .707-1.707l-9-9a1 1 0 0 0-1.414 0l-9 9A1 1 0 0 0 7 13zM25 19H7a1 1 0 0 0-.707 1.707l9 9a1 1 0 0 0 1.414 0l9-9A1 1 0 0 0 25 19z"
                              fill="#949494"
                              opacity="1"
                            />
                          </g>
                        </svg>
                      </span>
                    </th>
                    <th onClick={() => handleSort("inspection_date")}>
                      Date
                      <span className="ms-1">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          version="1.1"
                          width="10"
                          height="17"
                          viewBox="0 0 32 32"
                        >
                          <g>
                            <path
                              d="M7 13h18a1 1 0 0 0 .707-1.707l-9-9a1 1 0 0 0-1.414 0l-9 9A1 1 0 0 0 7 13zM25 19H7a1 1 0 0 0-.707 1.707l9 9a1 1 0 0 0 1.414 0l9-9A1 1 0 0 0 25 19z"
                              fill="#949494"
                              opacity="1"
                            />
                          </g>
                        </svg>
                      </span>
                    </th>
                    <th>Inspector</th>
                    <th onClick={() => handleSort("status")}>
                      Status
                      <span className="ms-1">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          version="1.1"
                          width="10"
                          height="17"
                          viewBox="0 0 32 32"
                        >
                          <g>
                            <path
                              d="M7 13h18a1 1 0 0 0 .707-1.707l-9-9a1 1 0 0 0-1.414 0l-9 9A1 1 0 0 0 7 13zM25 19H7a1 1 0 0 0-.707 1.707l9 9a1 1 0 0 0 1.414 0l9-9A1 1 0 0 0 25 19z"
                              fill="#949494"
                              opacity="1"
                            />
                          </g>
                        </svg>
                      </span>
                    </th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>

                  {inspection.length > 0 ? (
                    inspection.map((inspection, index) =>
                    (
                      <tr key={inspection.id}>
                        <td>{inspection.inspection_name}</td>
                        <td>
                          {" "}
                          {inspection.project_streetaddress}{" "}
                          {inspection.porject_suburb} {inspection.state_name}{" "}
                          {inspection.project_postCode}
                        </td>
                        <td
                          style={{
                            textAlign: !inspection.inspection_date
                              ? "center"
                              : "left",
                          }}
                        >
                          {inspection.inspection_date
                            ? new Date(
                              inspection.inspection_date
                            ).toLocaleDateString()
                            : "-"}
                        </td>
                        <td>
                          {inspection.inspectors &&
                            inspection.inspectors.length > 0
                            ? inspection.inspectors
                              .map((inspector) =>
                                inspector?.first_name || inspector?.last_name
                                  ? `${inspector.first_name || ""} ${inspector.last_name || ""
                                    }`.trim()
                                  : null
                              )
                              .filter(Boolean) // remove nulls
                              .join(", ") || "No Inspectors"
                            : "No Inspectors"}
                        </td>
                        <td>{inspection.status}</td>
                        <td>
                          <div className="d-flex gap-3">
                            <a
                              className="tooltip-container d-flex align-items-center text-decoration-none fonticon"
                              onClick={() =>
                                navigate(`/view-inspection/${inspection.id}`)
                              }
                            >
                              <i className="fas fa-eye me-2"></i>
                              <span className="tooltip-text">View</span>
                            </a>
                            <a
                              className="tooltip-container d-flex align-items-center text-decoration-none fonticon"
                              onClick={() =>
                                navigate(`/update-inspection/${inspection.id}`)
                              }
                            >
                              <i className="fas fa-pencil-alt me-2"></i>
                              <span className="tooltip-text">Update</span>
                            </a>
                            <a
                              className="tooltip-container d-flex align-items-center text-decoration-none fonticon"
                              href="#"
                              data-bs-toggle="modal"
                              data-bs-target="#deletemodal"
                              onClick={() => setSelectedId(inspection.id)}
                            >
                              <i className="fas fa-trash me-2"></i>
                              <span className="tooltip-text">Delete</span>
                            </a>
                            <a
                              className="tooltip-container d-flex align-items-center text-decoration-none fonticon"
                              href="#"
                              data-bs-toggle="modal"
                              data-bs-target="#cloneModel"
                              onClick={() => setSelectedId(inspection.id)}
                            >
                              <i class="fa-solid fa-clone"></i>
                              <span className="tooltip-text">Clone</span>
                            </a>

                            <a
                              className="tooltip-container d-flex align-items-center text-decoration-none fonticon"
                              href="#"
                              data-bs-toggle="modal"
                              data-bs-target="#archiveemodal"
                              onClick={() => setSelectedId(inspection.id)}
                            >
                              <i class="fa fa-archive" aria-hidden="true"></i>
                              <span className="tooltip-text">Archive</span>
                            </a>

                            <a
                              className="d-flex align-items-center text-decoration-none fonticon tooltip-container"
                              href="#"
                              onClick={(e) => {
                                e.preventDefault();
                                if (inspection.status === "Complete") {
                                  navigate(`/start-inspection/${inspection.template_id}`, {
                                    state: {
                                      inspectionId: inspection.id,
                                      start_time: new Date().toISOString(),
                                    },
                                  });
                                } else {

                                  setSelectedId(inspection.template_id);
                                  setInspectionId(inspection.id);
                                  setInspectionStatus(inspection.status);

                                  const modal = new Modal(document.getElementById('inspectionmodal'));
                                  modal.show();
                                }
                              }}
                            >
                              {
                                inspection.status === "Complete" ?
                                  <>
                                    <i className="fa-solid fa-file-pen"></i>
                                    <span className="tooltip-text">Update Inspection</span>
                                  </> :
                                  <>
                                    <i className="fas fa-plus me-2"></i>
                                    <span className="tooltip-text">Start Inspection</span>
                                  </>
                              }
                            </a>

                            {/* Start Inspection Modal */}
                            <div
                              className="modal fade"
                              id="inspectionmodal"
                              tabindex="-1"
                              aria-labelledby="inspectionmodallabel"
                              aria-hidden="true"
                            >
                              <div className="modal-dialog modal-dialog-centered delete-modal">
                                <div className="modal-content">
                                  <div className="modal-body">
                                    <div className="text-center delete-img-blk">
                                      <img src={deleteimg} alt="start-inspection" />
                                    </div>
                                    {
                                      inspectionStatus === "Complete" ?
                                        (
                                          <div className="ques-title text-center">
                                            Inspection already Done.
                                            <p className="m-0">Do you want to update the inspection?</p>
                                          </div>
                                        ) :
                                        (
                                          <div className="ques-title text-center">

                                            Are you sure?
                                            <p className="m-0">
                                              Are you sure you want to start the inspection?
                                            </p>
                                          </div>
                                        )
                                    }

                                  </div>
                                  <div className="d-flex align-items-center justify-content-center gap-3 btn-block">
                                    <button
                                      type="button"
                                      className="gray-outline-btn"
                                      data-bs-dismiss="modal"
                                    >
                                      Cancel
                                    </button>
                                    <button
                                      type="button"
                                      className="orange-btn"
                                      data-bs-dismiss="modal"
                                      onClick={() => {
                                        navigate(`/start-inspection/${selectedId}`, {
                                          state: { inspectionId: inspectionId, start_time: new Date().toISOString() }
                                        });
                                      }}
                                    > {
                                        inspectionStatus === "Complete" ?
                                          "Update Inspection" :
                                          "Start Inspection"
                                      }


                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>


                            {/* Clone Confirmation Model */}

                            <div
                              class="modal fade"
                              id="cloneModel"
                              tabindex="-1"
                              aria-labelledby="deletemodalLabel"
                              aria-hidden="true"
                            >
                              <div class="modal-dialog modal-dialog-centered delete-modal">
                                <div class="modal-content">
                                  <div class="modal-body">
                                    <div className="ques-title text-center">
                                      Are you sure ?
                                      <p className="m-0">
                                        Do you want to clone the inspection
                                        record?
                                      </p>
                                    </div>
                                  </div>
                                  <div className="d-flex align-items-center justify-content-center gap-3 btn-block">
                                    <button
                                      type="button"
                                      class="gray-outline-btn"
                                      data-bs-dismiss="modal"
                                    >
                                      Cancel
                                    </button>
                                    <button
                                      type="button"
                                      class="orange-btn"
                                      data-bs-dismiss="modal"
                                      onClick={cloneInspection}
                                    >
                                      Yes
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="7" className="text-center">
                        No Inspection found
                      </td>
                    </tr>
                  )
                  }
                </tbody>
              </table>
            </div>

            {/* responsive */}
            <div className="mobile-table-card d-block d-md-none">
              {inspection?.length > 0
                ? (
                  inspection.map((inspection) => (
                    <div key={inspection.id} className="user-card">
                      <div className="data-card mb-3 p-3 border rounded">
                        <div className="mb-2">
                          <strong>Inspection Title:</strong>{inspection.inspection_name}
                        </div>
                        <div className="mb-2">
                          <strong>Project Address:</strong>{inspection.project_streetaddress}
                        </div>
                        <div className="mb-2">
                          <strong>Date:</strong>{inspection.inspection_date
                            ? new Date(
                              inspection.inspection_date
                            ).toLocaleDateString()
                            : "-"}
                        </div>
                        <div className="mb-2">
                          <strong>Inspector:</strong>{inspection.inspectors &&
                            inspection.inspectors.length > 0
                            ? inspection.inspectors
                              .map((inspector) =>
                                inspector?.first_name || inspector?.last_name
                                  ? `${inspector.first_name || ""} ${inspector.last_name || ""
                                    }`.trim()
                                  : null
                              )
                              .filter(Boolean) // remove nulls
                              .join(", ") || "No Inspectors"
                            : "No Inspectors"}
                        </div>
                        <div className="mb-2">
                          <strong>Status:</strong>{inspection.status}
                        </div>


                        <div className="d-flex justify-content-end mt-3 gap-3">
                          <a
                            className="d-flex align-items-center text-decoration-none fonticon"
                            onClick={() =>
                              navigate(`/view-inspection/${inspection.id}`)
                            }
                          >
                            <i className="fas fa-eye me-2"></i>
                          </a>
                          <a
                            className="d-flex align-items-center text-decoration-none fonticon"
                            onClick={() =>
                              navigate(`/update-inspection/${inspection.id}`)
                            }
                          >
                            <i className="fas fa-pencil-alt me-2"></i>
                          </a>

                          <a
                            className="tooltip-container d-flex align-items-center text-decoration-none fonticon"
                            href="#"
                            data-bs-toggle="modal"
                            data-bs-target="#cloneModel1"
                            onClick={() => setSelectedId(inspection.id)}
                          >
                            <i class="fa-solid fa-clone"></i>
                            <span className="tooltip-text">Clone</span>
                          </a>
                          <a
                            className="tooltip-container d-flex align-items-center text-decoration-none fonticon"
                            href="#"
                            data-bs-toggle="modal"
                            data-bs-target="#archiveemodal"
                            onClick={() => setSelectedId(inspection.id)}
                          >
                            <i class="fa fa-archive" aria-hidden="true"></i>
                            <span className="tooltip-text">Archive</span>
                          </a>

                          <a
                            className="tooltip-container d-flex align-items-center text-decoration-none fonticon"
                            href="#"
                            onClick={(e) => {
                              e.preventDefault();
                              if (inspection.status === "Complete") {
                                navigate(`/start-inspection/${inspection.template_id}`, {
                                  state: {
                                    inspectionId: inspection.id,
                                    start_time: new Date().toISOString(),
                                  },
                                });
                              } else {

                                setSelectedId(inspection.template_id);
                                setInspectionId(inspection.id);
                                setInspectionStatus(inspection.status);

                                const modal = new Modal(document.getElementById('inspectionmodal1'));
                                modal.show();
                              }
                            }}
                          // data-bs-toggle="modal"
                          // data-bs-target="#inspectionmodal1"
                          // onClick={() => {
                          //   setSelectedId(inspection.template_id);
                          //   setInspectionStatus(inspection.status);
                          //   setInspectionId(inspection.id)
                          // }}
                          >
                            {
                              inspection.status === "Complete" ?
                                <>
                                  <i className="fa-solid fa-file-pen"></i>

                                </> :
                                <>
                                  <i className="fas fa-plus me-2"></i>
                                  <span className="tooltip-text">Start Inspection</span>
                                </>
                            }
                          </a>

                          {/* clone modal */}

                          <div
                            class="modal fade"
                            id="cloneModel1"
                            tabindex="-1"
                            aria-labelledby="deletemodalLabel"
                            aria-hidden="true"
                          >
                            <div class="modal-dialog modal-dialog-centered delete-modal">
                              <div class="modal-content">
                                <div class="modal-body">
                                  <div className="ques-title text-center">
                                    Are you sure ?
                                    <p className="m-0">
                                      Do you want to clone the inspection
                                      record?
                                    </p>
                                  </div>
                                </div>
                                <div className="d-flex align-items-center justify-content-center gap-3 btn-block">
                                  <button
                                    type="button"
                                    class="gray-outline-btn"
                                    data-bs-dismiss="modal"
                                  >
                                    Cancel
                                  </button>
                                  <button
                                    type="button"
                                    class="orange-btn"
                                    data-bs-dismiss="modal"
                                    onClick={cloneInspection}
                                  >
                                    Yes
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* start inspection modal */}
                          <div
                            className="modal fade"
                            id="inspectionmodal1"
                            tabindex="-1"
                            aria-labelledby="deletemodal"
                            aria-hidden="true"
                          >
                            <div className="modal-dialog modal-dialog-centered delete-modal">
                              <div className="modal-content">
                                <div className="modal-body">
                                  <div className="text-center delete-img-blk">
                                    <img src={deleteimg} alt="start-inspection" />
                                  </div>
                                  {
                                    inspectionStatus === "Complete" ?
                                      (
                                        <div className="ques-title text-center">
                                          Inspection already Done.
                                          <p className="m-0">Do you want to update the inspection?</p>
                                        </div>
                                      ) :
                                      (
                                        <div className="ques-title text-center">

                                          Are you sure?
                                          <p className="m-0">
                                            Are you sure you want to start the inspection?
                                          </p>
                                        </div>
                                      )
                                  }

                                </div>
                                <div className="d-flex align-items-center justify-content-center gap-3 btn-block">
                                  <button
                                    type="button"
                                    className="gray-outline-btn"
                                    data-bs-dismiss="modal"
                                  >
                                    Cancel
                                  </button>
                                  <button
                                    type="button"
                                    className="orange-btn"
                                    data-bs-dismiss="modal"
                                    onClick={() => {
                                      navigate(`/start-inspection/${selectedId}`, {
                                        state: { inspectionId: inspectionId, start_time: new Date().toISOString() }
                                      });
                                    }}
                                  > {
                                      inspectionStatus === "Complete" ?
                                        "Update Inspection" :
                                        "Start Inspection"
                                    }
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  ))
                )
                : (
                  <div className="text-center">
                    No Inspection found
                  </div>
                )
              }
            </div>


            <div className="pagination-block">
              {
                <Pagination
                  count={totalRecords}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onChangePage={handleChangePage}
                  onRowsPerPageChange={handleRowsPerPageChange}
                />
              }
            </div>
          </div>
        </div>

        {/* delete modal */}
        <div
          class="modal fade"
          id="deletemodal"
          tabindex="-1"
          aria-labelledby="deletemodalLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-dialog-centered delete-modal">
            <div class="modal-content">
              <div class="modal-body">
                <div className="text-center delete-img-blk">
                  <img src={deleteimg} alt="delete-img"></img>
                </div>
                <div className="ques-title text-center">
                  Are you sure ?
                  <p className="m-0">
                    Are you sure you really want to delete this record? This
                    process cannot be undone.
                  </p>
                </div>
              </div>
              <div className="d-flex align-items-center justify-content-center gap-3 btn-block">
                <button
                  type="button"
                  class="gray-outline-btn"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  class="orange-btn"
                  data-bs-dismiss="modal"
                  onClick={handleDelete}
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* archive modal  */}
        <div
          class="modal fade"
          id="archiveemodal"
          tabindex="-1"
          aria-labelledby="archiveemodalLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-dialog-centered delete-modal">
            <div class="modal-content">
              <div class="modal-body">
                <div className="text-center delete-img-blk">
                  <img src={deleteimg} alt="delete-img"></img>
                </div>
                <div className="ques-title text-center">
                  Are you sure ?
                  <p className="m-0">
                    Are you sure you really want to archive this record?
                  </p>
                </div>
              </div>
              <div className="d-flex align-items-center justify-content-center gap-3 btn-block">
                <button
                  type="button"
                  class="gray-outline-btn"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  class="orange-btn"
                  data-bs-dismiss="modal"
                  onClick={handleArchive}
                >
                  Archive
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>


    </div>
  );
};

export default ProjectDetails;
